const user = {
    state: {
        detailInfo: {

        },
    },
    mutations: {
        UPDATE_USERINFO: (state, data) => {
            state.detailInfo = data
        },
        DELETE_USERINFO: (state, data) => {
            state.detailInfo = {}
        },
    },
    actions: {
        updateUserInfo ({ commit }, data) {
            commit('UPDATE_USERINFO', data)
        },
        delUserInfo ({ commit }, data) {
            commit('DELETE_USERINFO')
        }
    }
}

export default user
